import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {TwoRowItemCard} from 'shells/two-row-item/two-row-item-card';
import {Body} from 'shells/typography/body';

import {DecisionFieldRule} from '../../../create-rules/decision-field-rule';

import type {FormSchemaProperty} from '../../../../../core/nutshell-fields/types';
import type {InputFormField} from '../../../../types';

import {AnswerRuleNextStepSelect} from './answer-rule-next-step-select';

type Props = {
    formId: string;
    fieldSchema: FormSchemaProperty;
    currentField: InputFormField;
    onCancel: () => void;
    onSave: (answerEnumId: string, assignmentId: string, assignmentName: string) => void;
    isSaving: boolean;
};

export function AdditionalFormRule(props: Props) {
    const [selectedFieldId, setSelectedFieldId] = React.useState<string | null | undefined>(
        props.currentField.id
    );
    const [selectedOptionId, setSelectedOptionId] = React.useState<string | null | undefined>(null);

    const defaultOption = props.currentField.attributeId
        ? {
              fieldId: props.currentField.id,
              attributeId: props.currentField.attributeId,
              label: props.currentField.label,
          }
        : undefined;

    return (
        <StackLegacy spacing={8}>
            {!selectedFieldId || !selectedOptionId ? (
                <DecisionFieldRule
                    formId={props.formId}
                    fieldCondition={{
                        title: 'If...',
                        default: defaultOption,
                        isDisabled: true,
                        tooltip: defaultOption && defaultOption.label,
                    }}
                    optionCondition={{
                        title: 'Is:',
                    }}
                    onUpdate={(fieldId, optionId) => {
                        setSelectedFieldId(fieldId);
                        setSelectedOptionId(optionId);
                    }}
                />
            ) : (
                <StackLegacy spacing={8}>
                    <Body>If...</Body>
                    <TwoRowItemCard
                        topRow={props.currentField.label}
                        bottomRow={`is ${getOptionName(
                            props.fieldSchema,
                            selectedFieldId,
                            selectedOptionId
                        )}`}
                        onRemove={() => setSelectedOptionId(null)}
                    />
                </StackLegacy>
            )}
            {selectedOptionId && (
                <AnswerRuleNextStepSelect
                    entityType={props.currentField.entityType}
                    onCancel={() => {
                        setSelectedOptionId(null);
                        props.onCancel();
                    }}
                    isSaving={props.isSaving}
                    // @ts-expect-error
                    handleSubmit={(assignmentId, assignmentName) => {
                        props.onSave(selectedOptionId, assignmentId, assignmentName);
                    }}
                />
            )}
        </StackLegacy>
    );
}

const getOptionName = (
    fieldSchema: FormSchemaProperty,
    fieldId: string,
    optionId: string
): string => {
    const selectedOption = fieldSchema.options.find((option) => option.id === optionId);

    return selectedOption ? selectedOption.name : '';
};
